import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";
import { HiOutlineX } from "react-icons/hi";
import { nav } from "../data/siteData";
import "./MobileMenu.css";

export default function MobileMenu({ open, onClose }) {
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <div
      className={`mobile-menu ${open ? "mobile-menu--open" : ""}`}
      role="dialog"
      aria-modal="true"
      aria-hidden={!open}
    >
      <button
        type="button"
        className="mobile-menu__close"
        onClick={onClose}
        aria-label="Close menu"
      >
        <HiOutlineX size={26} />
      </button>
      <nav className="mobile-menu__links" aria-label="Mobile">
        {nav.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className="mobile-menu__link"
            onClick={onClose}
            tabIndex={open ? 0 : -1}
          >
            {item.label}
          </NavLink>
        ))}
      </nav>
      <NavLink
        to="/contact"
        className="btn btn-primary mobile-menu__cta"
        onClick={onClose}
        tabIndex={open ? 0 : -1}
      >
        Get Solar Quote
      </NavLink>
    </div>
  );
}
